/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { forwardRef } from 'react';

import { TextField } from '@coursera/cds-core';

import type { Props as TextInputProps } from 'bundles/authentication/shared/TextInput';
import TextInput from 'bundles/authentication/shared/TextInput';
import { commonStyles } from 'bundles/authentication/shared/commonStyles';
import GrowthDegreesExperiments from 'bundles/epic/clients/GrowthDegrees';

import _t from 'i18n!nls/authentication';

type PropsFromCaller = {
  label?: string;
  name?: string;
  placeholder?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  autoComplete?: 'name' | 'given-name' | 'family-name';
};

type PropsToComponent = PropsFromCaller &
  Omit<TextInputProps, keyof PropsFromCaller> & {
    value?: string | number;
  };

const NameInput = forwardRef<HTMLInputElement, PropsToComponent>(
  (
    {
      label = _t('Full Name'),
      name = 'name',
      placeholder = _t('Enter your full name'),
      defaultValue,
      autoComplete = 'name',
      ...props
    }: PropsToComponent,
    ref
  ) => {
    const useCDSOnRegForm = GrowthDegreesExperiments.get('useCDSOnRegForm');

    return useCDSOnRegForm ? (
      <TextField
        css={commonStyles.input}
        label={label}
        name={name}
        placeholder={placeholder}
        autoComplete={autoComplete}
        ref={ref}
        {...props}
      />
    ) : (
      <TextInput
        label={label}
        name={name}
        placeholder={placeholder}
        defaultValue={defaultValue}
        autoComplete={autoComplete}
        ref={ref}
        {...props}
      />
    );
  }
);
export default NameInput;
